import type { DmsTeamsResponse } from 'types/dmsTeam';
import { objectToQueryParams } from 'utils/linkUtil';
import { portalAPI } from './portalAPI';

const APIDmsTeamSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['DmsTeam'] }).injectEndpoints({
    endpoints: (builder) => ({
        // List DMS teams with pagination and search
        getDmsTeams: builder.query<DmsTeamsResponse, { page?: number; size?: number; search?: string }>({
            query: ({ page = 0, size = 20, search }) => {
                const params = objectToQueryParams({
                    page,
                    size,
                    ...(search && { search }),
                });
                return `/v1/dms/teams${params}`;
            },
            providesTags: ['DmsTeam'],
            transformErrorResponse: (response) => {
                console.error('Failed to fetch DMS teams:', response);
                return response;
            },
        }),

        // Check if OneDrive integration is enabled for tenant
        isOneDriveIntegrationEnabled: builder.query<boolean, void>({
            query: () => '/v1/integrations/onedrive/enabled',
            keepUnusedDataFor: 10 * 60,
            transformErrorResponse: (response) => {
                console.error('Failed to check OneDrive integration status:', response);
                return response;
            },
        }),
    }),
    overrideExisting: false,
});

// Export hooks for usage in functional components
export const { useLazyGetDmsTeamsQuery, useIsOneDriveIntegrationEnabledQuery } = APIDmsTeamSlice;
